import { createSlice } from "@reduxjs/toolkit";

interface CustomerState {
    account_ID            : string;
    account_name          : string;
    customer_ID           : number;
    customer_name         : string;
    customer_phone_number : string;
    customer_point        : string;
    customer_ablack_rate  : number;
    matching              : number;
    payment_ready         : number;
    payment_success       : number;
    construction_complete : number;
    cancel_reservation    : number;
    total_reservation     : number;
};

const initialState = {
    account_ID            : "",
    account_name          : "",
    customer_ID           : 0,
    customer_name         : "",
    customer_phone_number : "",
    customer_point        : "",
    customer_ablack_rate  : 0,
    matching              : 0,
    payment_ready         : 0,
    payment_success       : 0,
    construction_complete : 0,
    cancel_reservation    : 0,
    total_reservation     : 0,
} as CustomerState;

const CustomerSlice = createSlice({
    name : 'customer_data',
    initialState,
    reducers : {
        reduxChangeAccountID : (state, action) => {
            state.account_ID = action.payload;
        },
        reduxChangeAccountName : (state, action) => {
            state.account_name = action.payload;
        },
        reduxChangeCustomerID : (state, action) => {
            state.customer_ID = action.payload;
        },
        reduxChangeCustomerAblackRate : (state, action) => {
            state.customer_ablack_rate = action.payload;
        },
        reduxChangeCustomerName : (state, action) => {
            state.customer_name = action.payload;
        },
        reduxChangeCustomerPhoneNumber : (state, action) => {
            state.customer_phone_number = action.payload;
        },
        reduxChangeCustomerPoint : (state, action) => {
            state.customer_point = action.payload;
        },
        reduxChangeCustomerMatching : (state, action) => {
            state.matching = action.payload;
        },
        reduxChangeCustomerPaymentReady : (state, action) => {
            state.payment_ready = action.payload;
        },
        reduxChangeCustomerPaymentSuccess : (state, action) => {
            state.payment_success = action.payload;
        },
        reduxChangeCustomerSuccess : (state, action) => {
            state.construction_complete = action.payload;
        },
        reduxChangeCancelReservation : (state, action) => {
            state.cancel_reservation = action.payload;
        },
        reduxChangeTotalReservation : (state, action) => {
            state.total_reservation = action.payload;
        }
    }
});

export const {
    reduxChangeAccountID,
    reduxChangeAccountName,
    reduxChangeCustomerID,
    reduxChangeCustomerAblackRate,
    reduxChangeCustomerMatching,
    reduxChangeCustomerPaymentReady,
    reduxChangeCustomerPaymentSuccess,
    reduxChangeCustomerSuccess,
    reduxChangeCustomerName,
    reduxChangeCustomerPhoneNumber,
    reduxChangeCustomerPoint,
    reduxChangeCancelReservation,
    reduxChangeTotalReservation
} = CustomerSlice.actions;

export default CustomerSlice.reducer;